<template>
  <a
    class="card--product"
    v-bind:href="permalink"
    v-bind:aria-label="name"
    data-mh="product-card"
  >
    <img :src="imageSrc" :alt="imageAlt" class="card__image" />
    <span v-if="categories.length > 0" class="card__terms">{{
      getCategoryList
    }}</span>
    <h4 class="card__title">{{ name }}</h4>
    <ul v-if="getAttributes.length > 0" class="nav flex-column card__list--product-attrs">
      <li v-for="(attribute, index) in getAttributes" :key="index">
        {{ attribute.label }}: {{ attribute.value }}
      </li>
    </ul>
  </a>
</template>
<script>
import Image from "../@types/Image";

export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    attributes: {
      type: Array,
      default: () => [],
      validator: (attributes) =>
        attributes.filter((attribute) => {
          attribute.hasOwnProperty("label") &&
            attribute.hasOwnProperty("value");
        }),
    },
    thumbnail: [Boolean, Number, Image, Object],
    permalink: String,
    slug: String,
    categories: {
      type: Array,
      default: [],
    },
    tags: Array,
  },
  computed: {
    getAttributes() {
      return this.attributes.filter(attribute => attribute.value !== null && attribute.hasOwnProperty('value'))
    },
    getCategoryList() {
      var list = [];

      this.categories.forEach((category) => {
        list.push(category.name);
      });

      return list.join(", ");
    },
    imageSrc() {
      if (this.thumbnail && this.thumbnail.hasOwnProperty("src")) {
        return this.thumbnail.src;
      } else {
        return "//placehold.it/300x300";
      }
    },
    imageAlt() {
      if (this.thumbnail && this.thumbnail.hasOwnProperty("alt")) {
        return this.thumbnail.alt;
      } else {
        return this.name;
      }
    },
  },
};
</script>
